import { render, staticRenderFns } from "./UpsellPaymentBanner.vue?vue&type=template&id=32bb9f66&scoped=true"
import script from "./UpsellPaymentBanner.vue?vue&type=script&lang=js"
export * from "./UpsellPaymentBanner.vue?vue&type=script&lang=js"
import style0 from "./UpsellPaymentBanner.vue?vue&type=style&index=0&id=32bb9f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb9f66",
  null
  
)

export default component.exports